import { render } from "./HelloWorld.vue?vue&type=template&id=80b2d890&scoped=true&ts=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=80b2d890&scoped=true&lang=scss"

import exportComponent from "E:\\hermes\\hermes-projects\\new-violin-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80b2d890"]])

export default __exports__